import type { TicketTypeList } from "@/types/init";

export type PassengerCountKey =
  | "adultMYS"
  | "childMYS"
  | "infantMYS"
  | "adultForeign"
  | "childForeign"
  | "infantForeign"
  | "local"
  | "foc"
  | "worker";

export const getPassengerCountKey = (
  ticket: TicketTypeList,
): PassengerCountKey | null => {
  const type = ticket.ticketTypeName.trim().toLowerCase();
  const category = ticket.categoryName.trim().toLowerCase();

  if (category === "malaysian") {
    if (type === "adult") return "adultMYS";
    if (type === "child") return "childMYS";
    if (type === "infant") return "infantMYS";
  }

  if (category === "foreigner") {
    if (type === "adult" || type === "adult foreigner") {
      return "adultForeign";
    }

    if (type === "child" || type === "child foreigner") {
      return "childForeign";
    }

    if (type === "infant" || type === "infant foreigner") {
      return "infantForeign";
    }
  }

  if (category === "local" && type === "local") {
    return "local";
  }

  if (
    (type === "foc" || type === "free pass") &&
    category === "malaysian foc"
  ) {
    return "foc";
  }

  if (type === "worker" && category === "malaysian worker") {
    return "worker";
  }

  return null;
};